export const IconCheck = () => 
    <svg className="stroke-current" xmlns="http://www.w3.org/2000/svg" width="11.433" height="8.33" viewBox="0 0 11.433 8.33">
        <path 
            d="M12.6,6,6.689,11.915,4,9.227" transform="translate(-2.586 -4.586)" fill="none" 
            strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
        />
    </svg>